/**
 * GraphQL queries and hooks — techRadar pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { TechRadarFilter, TechRadarResult } from '../types/techRadar';

export const TECH_RADAR = gql`
  query TechRadar($filter: TechRadarFilter) {
    techRadar(filter: $filter) {
      sectors {
        label
        families
      }
      blips {
        id
        name
        ring
        sector
        family
        description
        supplier
        isNew
      }
    }
  }
`;

export function useTechRadar(
  filter?: TechRadarFilter,
  skip?: boolean
): QueryResult<{ techRadar: TechRadarResult }> {
  return useQuery(TECH_RADAR, {
    variables: { filter },
    skip,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
}

// ─── Search ────────────────────────────────────────────────────────────────
